import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import { Fade } from "react-awesome-reveal";
import styled from "styled-components";

export const StyledBenefitsList = styled(Fade)`
  display: flex;
  flex-direction: column;
  list-style: none;
  width: 100%;
`;

export const StyledBenefitsItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 56px;
  padding-bottom: 56px;
  border-bottom: 1px solid ${EColors.neutral_200};
  @media screen and (max-width: 767px) {
    flex-direction: column;
    gap: 24px;
    padding-top: 24px;
    padding-bottom: 24px;
  }
`;

export const StyledCountWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: transparent;
  z-index: 0;
  width: 50%;
  height: 59px;
  flex-shrink: 0;
  @media screen and (max-width: 767px) {
    width: 100%;
    height: 47px;
  }
`;
export const StyledTitle = styled(Styled.H3)`
  margin-left: 69px;
  @media screen and (max-width: 767px) {
    margin-left: 59px;
  }
`;
export const IconEllipse = styled.svg<{
  fill: string;
}>`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  width: 49px;
  height: 59px;
  fill: ${(props) => props.fill};
  z-index: 1;
  @media screen and (max-width: 767px) {
    width: 39px;
    height: 47px;
  }
`;

export const StyledNumberWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(75%, -50%);
  font-weight: 600;
  font-size: 36px;
  line-height: 114%;
  text-align: center;
  font-feature-settings: "case" on;
  color: ${EColors.white};
  z-index: 2;
  @media screen and (max-width: 767px) {
    font-size: 28px;
  }
`;

export const StyledContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 768px) {
    flex-direction: row;
    gap: 24px;
  }
`;

export const StyledTextWrapper = styled.div`
  width: 50%;
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
  font-feature-settings: "case" on;
  color: ${EColors.neutral_700};
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;
